import { render, staticRenderFns } from "./HelpMenuPage.vue?vue&type=template&id=250034f4&"
import script from "./HelpMenuPage.vue?vue&type=script&lang=ts&"
export * from "./HelpMenuPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports